const state = {
    module: [],
    loading: false
};

export default state;